import React from 'react';
import T from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import LegendApp from './LegendApp';
import AppsDropdown from './AppsDropdown';
import TimeSpendChart from './TimeSpendChart';
import SegmentTransitions from './SegmentTransitions';
import Tooltip from '../../../../components/Tooltip';
import SimpleCard from '../../../../components/Card/SimpleCard';
import ErrorStateWithReload from '../../../../components/ErrorStateWithReload';
import { aiAppTrendsSelector, aiDashboardAppsSelector } from '../../selectors';
import { fetchAiAppTrends, fetchSegmentTransitions } from '../../actions';

const AppTrendsCard = ({ isPress }) => {
  const dispatch = useDispatch();

  const { data, settings, filters } = useSelector(aiAppTrendsSelector);
  const apps = useSelector(aiDashboardAppsSelector);

  const handleAppChange = (value) => {
    dispatch(fetchAiAppTrends({ app_uid: value }));
    dispatch(fetchSegmentTransitions({ app_uid: value }));
  };

  return (
    <SimpleCard
      headerLeft={
        <>
          <h3 className="h3 header-heading">App Trends</h3>
          <p className="header-description">
            Explore engagement patterns for a selected AI app and how different segments interact
            with it.
          </p>
        </>
      }
      headerRight={
        <AppsDropdown
          pending={apps.settings.pending}
          selected={filters.app_uid}
          options={apps.data?.top_apps}
          onChange={handleAppChange}
        />
      }
      contentDisableGutters
      actionsLeft={<div className="highcharts-watermark" />}
      className="app-trends-card"
    >
      {settings.error ? (
        <ErrorStateWithReload className="py-lg" />
      ) : (
        <div className="app-trends">
          <TimeSpendChart
            isPending={settings.pending}
            series={data.time_series}
            title="Average Time Spent per Day"
            footerRight={<LegendApp />}
            className="app-trends__time-spend-chart"
            isPress={isPress}
          />
          <TimeSpendChart
            isPending={settings.pending}
            series={data.cohort_distribution_series}
            isColumn
            title={
              <>
                High vs. Medium-Frequency Split{' '}
                <Tooltip
                  colorVariant="light"
                  content="This chart shows how the app’s AI-active users are split between High and Medium-Frequency segments. Low-Frequency, and Churned users are not included."
                  overlayStyle={{ maxWidth: 324 }}
                >
                  <i className="hicon-question-circle" />
                </Tooltip>
              </>
            }
            footerRight={<LegendApp />}
            className="app-trends__cohort-chart"
            isPress={isPress}
          />
        </div>
      )}
      <SegmentTransitions isPress={isPress} />
    </SimpleCard>
  );
};

AppTrendsCard.propTypes = {
  isPress: T.bool,
};

export default AppTrendsCard;
